import { render, staticRenderFns } from "./quesPointSelector.vue?vue&type=template&id=b07dc86e"
import script from "./quesPointSelector.vue?vue&type=script&lang=js"
export * from "./quesPointSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports